/** Tipo de cadastro escolhido ao criar nova conta a pagar. */
export type AccountsPayableCreateMode = 'normal' | 'parcelado' | 'rateio';

export const ACCOUNTS_PAYABLE_CREATE_MODE_LABELS: Record<AccountsPayableCreateMode, string> = {
  normal: 'Pagamento normal',
  parcelado: 'Pagamento parcelado (uma conta)',
  rateio: 'Divisão em centro de custo'
};
